import React from 'react';
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const EngineSignalTable = ({ rows = [] }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Engine Signals</Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Symbol</TableCell>
              <TableCell>Timeframe</TableCell>
              <TableCell>Trend</TableCell>
              <TableCell>Signal</TableCell>
              <TableCell align="right">Confidence</TableCell>
              <TableCell>Risk</TableCell>
              <TableCell>Execution</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={`${row.symbol}-${row.timeframe}`}>
                <TableCell>{row.symbol}</TableCell>
                <TableCell>{row.timeframe}</TableCell>
                <TableCell>{row.trend}</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={row.signal}
                    color={row.signal === 'LONG' ? 'success' : row.signal === 'SHORT' ? 'error' : 'default'}
                  />
                </TableCell>
                <TableCell align="right">{Number(row.confidence || 0)}%</TableCell>
                <TableCell>{row.risk || '-'}</TableCell>
                <TableCell>{row.executionAction || '-'}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={7}>
                  <Box sx={{ py: 2, textAlign: 'center', color: 'text.secondary' }}>
                    No signals
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default EngineSignalTable;
